import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div>
          <h3>Yaich Translations</h3>
          <p>Professional English to Arabic translation services in the UK.</p>
        </div>

        <div className="footer-links">
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#credentials">Credentials</a>
          <a href="/contact">Contact</a>
        </div>
      </div>
    </footer>
  );
}